import React from 'react'
import FinancialOfficerForm from './FinancialOfficerForm'
import Button from '../../ui/buttons/Button'

const FinancialOfficerFormList = ({ officer, onChange, canWrite = true }) => {
  const hasOfficer = officer && !officer._destroy

  const handleChange = (index, updated) => {
    onChange(updated)
  }

  const handleAdd = () => {
    if (!hasOfficer) {
      onChange({ name: '', cpf: '', kinship: '', birth_date: '', _destroy: false })
    }
  }

  const handleRemove = () => {
    if (officer.id) {
      onChange({ ...officer, _destroy: true })
    } else {
      onChange(null)
    }
  }

  return (
    <>
      <div className="space-y-4 bg-tealWhisper rounded-xl border border-tealPale p-5">
        {hasOfficer && (
          <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
            <FinancialOfficerForm
              index={0}
              officer={officer}
              onChange={handleChange}
              onRemove={handleRemove}
              canWrite={canWrite}
            />
          </div>
        )}
      </div>

      {canWrite && (
        <div className="pt-4">
          <Button onClick={handleAdd} type="button" disabled={hasOfficer}>
            + ADICIONAR RESPONSÁVEL
          </Button>
        </div>
      )}
    </>
  )  
}

export default FinancialOfficerFormList
